import React from "react";
import { greenCheck } from "../assets";

const Comparison = () => {
  return (
    <section id="comparison" className="sm:my-32 my-16">
      <div className="flex flex-col items-center justify-center w-full">
  <div className="flex flex-row flex-wrap justify-center items-start gap-12 w-full max-w-5xl" style={{alignItems: 'flex-start'}}>
          {/* Without Column */}
          <div className="flex-1 bg-transparent rounded-xl p-6 flex flex-col items-center min-w-[300px] mt-8">
            <div className="flex flex-col items-center mb-4">
              <span className="text-6xl mb-2 text-red-500">❌</span>
              <h2 className="text-2xl font-bold mb-2 text-white">Without Bright Ripple Studios</h2>
            </div>
            <ul className="text-left text-lg space-y-4 text-white">
              <li className="flex items-center"><span className="text-red-500 mr-2 text-xl">✗</span>Hours wasted on scripting, rehearsing, and recording videos.</li>
              <li className="flex items-center"><span className="text-red-500 mr-2 text-xl">✗</span>No personal connection and flat script.</li>
              <li className="flex items-center"><span className="text-red-500 mr-2 text-xl">✗</span>Ghost digital presence with missed opportunities.</li>
              <li className="flex items-center"><span className="text-red-500 mr-2 text-xl">✗</span>Inconsistent posting and low engagement.</li>
            </ul>
          </div>
          {/* With Column */}
          <div className="flex-1 bg-transparent rounded-xl p-6 flex flex-col items-center min-w-[300px]" style={{marginTop: '3mm'}}>
            <div className="flex flex-col items-center mb-4">
              <img src={greenCheck} alt="Green Check" className="w-20 h-20 mb-2" />
              <h2 className="text-2xl font-bold mb-2 text-white">With Bright Ripple Studios</h2>
            </div>
            <ul className="text-left text-lg space-y-4 text-white">
              <li className="flex items-center"><span className="text-green-500 mr-2 text-xl">✓</span>AI Digital Twin (one-time process) creates videos that look & sound like you—no camera needed.</li>
              <li className="flex items-center"><span className="text-green-500 mr-2 text-xl">✓</span>Value-driven scripts that include your opinions—we bring that power forward with you.</li>
              <li className="flex items-center"><span className="text-green-500 mr-2 text-xl">✓</span>We bend with algorithm trends and audience psychology while leaving room for 30% new creativity to double down on what works best.</li>
              <li className="flex items-center"><span className="text-green-500 mr-2 text-xl">✓</span>Complete production + social media management handled for you.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
